import React, { useState } from 'react';
import Arrows from './Arrows';
import {
  DOTS_WIDTH,
  DOTS_SPREAD_RATIO,
  HAIRLINE_WIDTH,
} from '../tool/Diagram';

export default ({
  from,
  to,
  width,
  fromIndex,
  radius = 100,
  turn = 50,
  stroke,
  strokeHover,
  showTooltip = () => {},
  conn,
}) => {
  const [hover, setHover] = useState(false);
  const dX = to.x - from.x;
  const dY = to.y - from.y;
  const minD = Math.min(Math.abs(dX));
  const rad = Math.min(minD / 2, radius);
  const turnPoint = turn / 100;

  const drawLine = () => {
    let baseD = '';
    // coefficients
    let coY;
    let coX;
    let sF1 = '0';

    if (dX > 0) {
      if (dY < 0) {
        coY = -1;
        coX = 1;
        sF1 = 0;
      } else {
        coY = 1;
        coX = 1;
        sF1 = 1;
      }
    } else {
      if (dY < 0) {
        coY = -1;
        coX = -1;
        sF1 = 1;
      } else {
        coY = 1;
        coX = -1;
        sF1 = 1;
      }
    }

    baseD = [
      `M ${from.x} ${from.y} `,
      `h ${dX - coX * rad}`,

      `a ${coX * rad} ${coY * rad} 90 0`,
      `${sF1} ${coX * rad} ${coY * rad}`,

      `v ${dY - rad * coY}`,
    ].join(' ');

    // console.log(baseD);
    return baseD;
  };

  let showArrow = true;
  let dir = dY < 0 ? 'l' : 'r';
  let aX = from.x + dX / 2 - rad * (dY > 0 ? 1 : -1);
  let aY = from.y;

  if (width < 10) {
    showArrow = false;
  }

  const clickHandler = () => {
    console.log(conn);
  };

  if (!stroke) {
    stroke = `url(#grad_${fromIndex})`;
    strokeHover = `url(#grad_${fromIndex}_hover)`;
  }

  let sDA = {};
  width = Math.max(conn.rawW, HAIRLINE_WIDTH);
  let shouldBeDotted =
    (conn.dottedOnlyIf0 && Math.abs(conn.data) < 0.01) ||
    (!conn.dottedOnlyIf0 && conn.rawW <= DOTS_WIDTH / 2);

  if (shouldBeDotted) {
    width = DOTS_WIDTH;
    sDA = {
      strokeDasharray: `${DOTS_WIDTH} ${DOTS_SPREAD_RATIO * DOTS_WIDTH}`,
    };
  }

  return (
    <>
      <path
        key={`${conn.rel}-path`}
        d={drawLine()}
        className="arrow"
        strokeWidth={width}
        {...sDA}
        stroke={stroke}
        fillOpacity={0}
        pointerEvents="stroke"
        onClick={clickHandler}
      />
      {showArrow && (
        <Arrows key={`${conn.rel}-arrow`} x={aX} y={aY} w={width} dir={dir} />
      )}
      <path
        key={`${conn.rel}-hover`}
        d={drawLine()}
        className="arrow"
        strokeWidth={width + 2}
        stroke={'#333'}
        strokeOpacity={0}
        fillOpacity="0"
        pointerEvents="stroke"
        onMouseEnter={(e) => {
          setHover(true);
          showTooltip({
            x: e.nativeEvent.clientX,
            y: e.nativeEvent.offsetY + 10,
            visible: true,
          });
        }}
        onMouseLeave={() => {
          setHover(false);
          showTooltip({
            visible: false,
          });
        }}
      />
    </>
  );
};
